export const resolutions = ['128', '256', '512', '1k'];
